import React from 'react';
import { GstManager, GstStateChoice } from '../components/GstManager';

export type { GstStateChoice };

type SellerGstManagerProps = {
    states: GstStateChoice[];
};

export const SellerGstManager: React.FC<SellerGstManagerProps> = ({ states }) => (
    <GstManager states={states} />
);
